import React from "react";
import styled, { css } from "styled-components";

import DropdownArrow from "icons/DropdownArrow";

import Media from "css/Media";

const InputCounter = React.forwardRef((props, ref) => {
  const handleOnChange = (e) => {
    let value = e.target.value;

    props.handleChange(props.name, value);
  };

  const handleOnClick = (dir) => {
    let value = props.value;
    if (dir === "+") {
      value++;
    } else if (dir === "-") {
      if (props.value > 1) value--;
    }
    props.handleChange(props.name, value);
  };

  return (
    <InputWrapper
      className={props.className}
      green={props.green}
      width={props.width}
      ref={ref}
    >
      <input
        min='1'
        type='number'
        onChange={(e) => handleOnChange(e)}
        value={props.value}
      />
      {props.unit && <span>{props.unit}</span>}
      <Counter onClick={() => handleOnClick("+")}>
        <StyledDropdownArrow />
      </Counter>
      <Counter onClick={() => handleOnClick("-")} decrement>
        <StyledDropdownArrow decrement />
      </Counter>
    </InputWrapper>
  );
});

export default InputCounter;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin: 0 auto 12px;
  height: ${(props) => props.theme.spacing.elementS};
  border: 1px solid
    ${(props) =>
      props.green ? props.theme.colors.button : props.theme.colors.input};
  background-color: transparent;
  transition: border 0.2s ease;
  padding: 0 16px;
  min-width: 120px;
  width: ${(props) => (props.width ? props.width + "px" : "100%")};

  &:hover,
  &:focus-within {
    border-color: ${(props) => props.theme.colors.text};
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  input[type="number"]:hover,
  input[type="number"]:focus {
    -moz-appearance: number-input;
  }
  input {
    width: auto;
    max-width: 25px;
    ${(props) => props.theme.fonts.p}
    font-size: 14px;
    margin-right: 3px;
    border: none;
    background: transparent;
    -webkit-appearance: none;
    text-align: right;

    &:-internal-autofill-previewed {
      background-color: transparent !important;
    }
    &:-internal-autofill-selected {
      background-color: transparent !important;
    }

    ${Media.greaterThan("s")`
            font-size: 16px;
        `}
  }

  span {
    ${(props) => props.theme.fonts.p}
    margin-right: 4px;
    white-space: nowrap;
  }
`;

const Counter = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  cursor: pointer;
  top: -2px;
  bottom: 100%;
  right: 0;
  padding-right: 25px;
  width: 50%;
  height: 50%;

  ${(props) =>
    props.decrement &&
    css`
      top: auto;
      bottom: -2px;
    `}
`;

const StyledDropdownArrow = styled(DropdownArrow)`
  align-self: flex-end !important;

  ${(props) =>
    props.decrement &&
    css`
      align-self: flex-start !important;
      transform: rotate(180deg);
    `}
`;
